module.exports = __webpack_public_path__ + "img/rainbow.27f9fc92.svg";